import DocumentImage from '@components/molecules/DocumentImage';
import { useHistory } from 'react-router-dom';
import { FileText, FolderOpen } from 'lucide-react';

interface DocumentModalProps {
  modalClose: any;
  project: any;
  initialData?: any | null | undefined;
}

const DocumentModal: React.FC<DocumentModalProps> = ({
  modalClose,
  project,
  initialData,
}) => {
  const history = useHistory();

  const PdfIframe = ({ pdfUrl }: { pdfUrl: string }) => (
    <div className="w-full h-[600px] rounded-lg overflow-hidden border border-gray-200 shadow-sm">
      <iframe
        src={pdfUrl}
        width="100%"
        height="100%"
        className="border-0"
        title="PDF Document"
      />
    </div>
  );

  const isPdf = (filename: string): boolean =>
    filename.toLowerCase().endsWith('.pdf');

  const navigateToProject = () => {
    history.push(`/projects/${project.projectId}`);
  };

  return (
    <div className=" rounded-xl w-full mx-auto overflow-hidden">
      {/* Content */}
      <div className="p-6 space-y-4">
        {/* Document Display */}
        <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
          <div className="flex justify-center">
            {!isPdf(initialData.name) ? (
              <div className="max-w-full">
                <DocumentImage src={initialData?.url} name={initialData.name} />
              </div>
            ) : (
              <PdfIframe pdfUrl={initialData.url} />
            )}
          </div>
        </div>

        {/* Document Info */}
        <div className="grid md:grid-cols-2 gap-4">
          {/* Project Information */}
          <div
            onClick={navigateToProject}
            className="bg-white flex items-center cursor-pointer justify-start rounded-xl border border-gray-200 p-4 shadow-sm hover:shadow-md transition-shadow duration-200">
            <div className="flex items-center space-x-3">
              <div className="flex items-center justify-center bg-blue-100 p-2 rounded-lg">
                <FolderOpen className="h-4 w-4 text-blue-600" />
              </div>
              <h3 className="text-sm font-semibold text-gray-900">
                {`Project: ${
                  project?.name
                    ? project?.name?.toUpperCase()
                    : initialData?.project?.name?.toUpperCase()
                }`}
              </h3>
            </div>
          </div>
          {/* Task Information */}
          {initialData.task?.name && (
            <div className="bg-white flex items-center justify-start rounded-xl border border-gray-200 p-4 shadow-sm hover:shadow-md transition-shadow duration-200">
              <div className="flex items-center space-x-3">
                <div className="flex items-center justify-center bg-orange-100 p-2 rounded-lg">
                  <FileText className="h-4 w-4 text-orange-600" />
                </div>
                <h3 className="text-sm font-semibold text-gray-900">
                  {`Task: ${initialData.task?.name?.toUpperCase()}`}
                </h3>
              </div>
            </div>
          )}
        </div>

        {/* Document Details */}
        <div className="bg-gray-50 rounded-xl p-6 border border-gray-100">
          <div className="grid gap-4">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-gray-600">
                File Name:
              </span>
              <span className="text-sm text-gray-900 font-medium">
                {initialData?.name?.toUpperCase() || 'N/A'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentModal;
